'use es6';

import { useSelector } from 'react-redux';
import { getIsPublicContent } from '../redux/selectors/blogSelectors';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncEditModuleSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'EditModuleSidebarContainer' */'ContentEditorUI/containers/EditModuleSidebarContainer'));
const SidebarPanelContainer = ({
  panelName,
  selectedModuleName,
  selectedField,
  editSidebarActiveTab
}) => {
  const isPublicContent = useSelector(getIsPublicContent);
  if (!panelName) {
    return null;
  } else if (panelName === SIDEBAR_PANELS.addWidget) {
    // Add sidebar panel has an iframe an is handled elsewhere
    return null;
  } else if (panelName === SIDEBAR_PANELS.preview) {
    // Preview modal is handled elsewhere (but it still a "sidebar panel" in the code from pre-Baymax logic)
    return null;
  } else if (panelName === SIDEBAR_PANELS.widgetList) {
    // Contents sidebar is handled by TreeViewModuleListContainer
    return null;
  } else if (panelName === SIDEBAR_PANELS.edit) {
    return /*#__PURE__*/_jsx(AsyncEditModuleSidebarContainer, {
      isPublicContent: isPublicContent,
      showDeviceToggle: false,
      selectedModuleInTree: null,
      selectedModuleName: selectedModuleName,
      selectedField: selectedField,
      editSidebarActiveTab: editSidebarActiveTab
    });
  }
  throw new Error(`Unknown panel: ${panelName}`);
};
export default SidebarPanelContainer;